import React from 'react'
import NoUserFound from '../NoUserFound.png'

interface NoUserFoundComponentProps {}

const NoUserFoundComponent: React.FC<NoUserFoundComponentProps> = () => {
  return (
    <div className='no-users-container'>
      <div className='no-users-wrapper'>
        <div className='col'>
          <div className='no_user_img'>
            <img 
              src={NoUserFound} 
              alt='No User Found' 
              style={{ width: '150px', height: 'auto' }} 
            />
          </div>
          <span className='no-record'>
            No User Details Found.
            <br />
            Kindly check with your Customer Sales Consultant for further assistance.
            <br />
          </span>
        </div>
      </div>
    </div>
  )
}

export default NoUserFoundComponent
